import Vue from "vue";
import Teaser from "./views/Teaser/Teaser.vue";
import Vuetify from "vuetify/lib";
import createRouter from "@/router";
import { getURLParamsObject } from "@/helpers/commonHelper";

Vue.config.productionTip = false;
Vue.use(Vuetify);

// loading wrapper for each instance
const $elements = document.getElementsByClassName("eoev-teaser-widget");
const savedElements = []; // save elements to array, since array will otherwise be reduce while looping
for (let i = 0; i < $elements.length; i++) {
  savedElements.push($elements[i]);
}

const colorConfig = getURLParamsObject(true);

for (let i = 0; i < savedElements.length; i++) {
  const $el = savedElements[i];

  const getColor = (key, defaultValue) =>
    $el.attributes[`data-${key}`]?.value || colorConfig?.[key] || defaultValue;

  // build vuetify instance using certain colors
  const opts = {
    icons: {
      iconfont: "mdiSvg"
    },
    theme: {
      themes: {
        light: {
          primary: getColor("color-primary", "#97bd0f"),
          secondary: getColor("color-secondary", "#5d7114"),
          accent: getColor("color-accent", "#2468c9"),
          error: getColor("color-error", "#c55c52"),
          info: getColor("color-info", "#314d57"),
          success: getColor("color-success", "#97bd0f"),
          warning: getColor("color-warning", "#e2d7af")
        }
      }
    }
  };
  const vuetify = new Vuetify(opts);

  // do we have initial data?
  const settings = $el.querySelector(".eoev-dv-widget-settings");

  // set as constants to avoid overwriting of settings below
  const id = $el.attributes.id && $el.attributes.id.value;
  const targetUri =
    $el.attributes["data-target-uri"] &&
    $el.attributes["data-target-uri"].value;
  const listUri =
    $el.attributes["data-list-uri"] && $el.attributes["data-list-uri"].value;
  const apiUrl =
    $el.attributes["data-api-url"] && $el.attributes["data-api-url"].value;
  const apiKey =
    $el.attributes["data-api-key"] && $el.attributes["data-api-key"].value;
  const locale =
    ($el.attributes["data-locale"] && $el.attributes["data-locale"].value) ||
    "de-de";
  const textColor = getColor("color-text", "#333");
  // teaser params
  const limit = parseInt(
    $el.attributes["data-limit"] && $el.attributes["data-limit"].value
  );
  const location =
    $el.attributes["data-location"] && $el.attributes["data-location"].value;
  const featureIds =
    ($el.attributes["data-features"] &&
      $el.attributes["data-features"].value &&
      $el.attributes["data-features"].value.split(",")) ||
    [];
  const categoryIds =
    ($el.attributes["data-categories"] &&
      $el.attributes["data-categories"].value &&
      $el.attributes["data-categories"].value.split(",")) ||
    [];
  const highlight = parseInt(
    $el.attributes["data-highlight"] && $el.attributes["data-highlight"].value
  );
  const sorting =
    $el.attributes["data-sorting"] && $el.attributes["data-sorting"].value;

  // create router
  const router = createRouter({
    ...settings,
    highlight
  });

  // no vuex here!
  new Vue({
    vuetify,
    router,
    render: function(h) {
      return h(Teaser, {
        props: {
          id: id,
          "target-uri": targetUri,
          "list-uri": listUri,
          "api-url": apiUrl,
          "api-key": apiKey,
          locale: locale,
          "initial-settings":
            (settings && JSON.parse(settings.innerHTML)) || undefined,
          limit: isNaN(limit) ? 3 : limit,
          location: location,
          "feature-ids": featureIds,
          "category-ids": categoryIds,
          highlight,
          sorting: sorting,
          textColor: textColor
        }
      });
    }
  }).$mount($el);
}
